var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(-1370 -8651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(1370 8651)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 28,
    height: 28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-twitter",
    "data-name": "Icon ionic-logo-twitter",
    d: "M23.534,6.633a9.175,9.175,0,0,1-2.606.717,4.554,4.554,0,0,0,2-2.513,9.018,9.018,0,0,1-2.883,1.1,4.537,4.537,0,0,0-7.852,3.1,4.443,4.443,0,0,0,.117,1.036A12.862,12.862,0,0,1,2.951,5.33,4.547,4.547,0,0,0,4.362,11.4,4.433,4.433,0,0,1,2.3,10.828v.056a4.542,4.542,0,0,0,3.642,4.453,4.568,4.568,0,0,1-1.2.159,4.281,4.281,0,0,1-.853-.084,4.546,4.546,0,0,0,4.242,3.155A9.1,9.1,0,0,1,2.5,20.513a9.2,9.2,0,0,1-1.083-.066A12.686,12.686,0,0,0,8.36,22.5,12.836,12.836,0,0,0,21.284,9.572c0-.2,0-.394-.014-.586A9.239,9.239,0,0,0,23.534,6.633Z",
    transform: "translate(1371.526 8651.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.94bfa75b575086bf17b6382de16f5eab.svg";
export { ForwardRef as ReactComponent };